<script setup>
import { Icon } from "@components"

const props = defineProps({
    iconSize: {
        type: String,
        Required: true
    },
    menus: {
        type: Array,
        default: () => {
            return []
        }
    }
})
</script>


<template>
    <div class="flex flex-col gap-1">
        <div class=" rounded-md mx-1.5 my-0.5 transition" v-for="(menu, index) in props.menus" :key="index">
            <router-link :to="menu.link" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                <Icon :name="menu.icon" :size="props.iconSize ? props.iconSize : '16px'" />
                <div class="text-[#344054] text-sm font-medium">{{ menu.title }}</div>
            </router-link>
        </div>
    </div>
</template>
